import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import './registerServiceWorker'
//import ElementUI from 'element-ui'
import resource from 'vue-resource'
//import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import { MessageBox } from 'element-ui'
import '@/assets/css/element-variables.scss';
const VueUploadComponent = require('vue-upload-component')
import BaiduMap from 'vue-baidu-map'
// 引入富文本
// import VueKindEditor from './plugin/kindeditor.js'
// import '../static/kindeditor/themes/default/default.css'
// import '../static/kindeditor/kindeditor-all-min.js'
// import '../static/kindeditor/lang/zh-CN.js'
// Vue.use(VueKindEditor)
// vue (third party)  inject
Vue.use(ElementUI)

Vue.use(resource)
Vue.use(BaiduMap,{ak:'4hkpimOlwyXpWunScBFO3L7812vVaFZa'})

Vue.config.productionTip = false
// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
	// Look for files in the current directory
	'./components',
	// Do not look in subdirectories
	false,
	// Only include "_base-" prefixed .vue files
	/u-[\w-]+\.vue$/
)

// For each matching file name...
requireComponent.keys().forEach(fileName => {
	// Get the component config
	const componentConfig = requireComponent(fileName)
	// Get the PascalCase version of the component name
	const componentName = upperFirst(
		camelCase(
			fileName
			// Remove the "./_" from the beginning
			.replace(/^\.\/_/, '')
			// Remove the file extension from the end
			.replace(/\.\w+$/, '')
		)
	)
	// Globally register the component
	Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.component('file-upload', VueUploadComponent)

Vue.mixin({
	methods: {
		$datumSane() {
			return new Promise((resolve, reject) => {
				let Id = this.$store.state.commonalityData.IdcodeUserId;
				if(!Id) {
					reject();
				} else {

					resolve(Id);
				}

			})

		},
		$GetQueryString(name) {
			let after = window.location.search;
			if(after.indexOf('?') === -1) return null; //如果url中没有传参直接返回空
			//key存在先通过search取值如果取不到就通过hash来取
			after = after.substr(1) || window.location.hash.split("?")[1];

			if(after) {
				let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				let r = after.match(reg);
				if(r != null) {
					return decodeURIComponent(r[2]);
				} else {
					return null;
				}
			}
		},
		resetForm(formName, uploadName) {
			this.$refs[formName].resetFields();
			if(uploadName != '') {
				this.$refs[uploadName].clearFiles();

			}
		},
		$getCookie(name) {
			var strCookie = document.cookie;
			var arrCookie = strCookie.split("; ");
			for(var i = 0; i < arrCookie.length; i++) {
				var arr = arrCookie[i].split("=");
				if(arr[0] == name)
					return arr[1];
			}
			return "";
		},
		$setCookie(cname, cvalue, exdays) {  
			var d = new Date();  
			d.setTime(d.getTime() + (exdays * 60 * 1000)); //设置date为当前时间+exdays分
			  
			var expires = "expires=" + d.toGMTString();  
			document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
		},
		$delCookie(name) {
			var exp = new Date();
			exp.setTime(exp.getTime() - 1);
			var cval = this.$getCookie(name);
			if(cval != null)
				document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
		},
	},
})

let instrumentVue = new Vue(); //工具vue

router.beforeEach((to, from, next) => {
	//next();

	if(to.matched.some(record => record.meta.jurisdictionPerfection)) {
		if(!store.state.commonalityData.IdcodeUserId && instrumentVue.$getCookie('Data') == '') {

			MessageBox.alert('请完善信息再使用此功能', '提示', {
				confirmButtonText: '完善信息',
				callback: (action, done) => {

					if(action === 'confirm') {

						router.push({
							path: '/perfect'
						})

					} else {
						router.push({
							path: '/'
						})

					}
					//					done()

				}
			});
		}
		//		else {
		//
		//			next()
		//
		//		}
		// if end
	}
	//	 else {
	//		console.log(2222)
	//		next({: '/'  });
	//
	//	}

	//	next()

	//if(to.query.hasOwnProperty('haha')){
	//	
	//}else{

	//}

	if(to.query.hasOwnProperty('user')) {
		next();
		if(to.query.user != unescape(instrumentVue.$getCookie('userName'))) {
			instrumentVue.$setCookie('userName', encodeURI(to.query.user))
		}
		//		return;
	} else {
		let Newto = { ...to
		};
		//console.log( instrumentVue.$getCookie('userName'))
		if(Newto.query.user == '') {
			instrumentVue.$setCookie('userName', encodeURI('null'))
			delete Newto.user;
		} else {
			Newto.query.user = decodeURI(instrumentVue.$getCookie('userName'));
		}

		next(Newto);

	}


})

// Vue.http.interceptors.push((request, next) => {
// 	request.params.yang = new Date().valueOf();
// 	next((res) => {
// 		if(res) {
// 			if(res.body.result === 505) {
// 				app.$delCookie('Data')
// 				app.$alert('尚未登录,请点击确定前往官网登录', '提示', {
// 					confirmButtonText: '确定',
// 					callback: () => {
// 						window.location.href = "../index.html";

// 					}
// 				});
// 			}
// 		}
// 	});
// });
Vue.prototype.$api = process.env.NODE_ENV === 'production' ? '/api' : '/api'

Vue.http.options.emulateJSON = true;

const app = new Vue({
	created() {
		//		console.log(!this.$getCookie('Data'))
		//		console.log(process.env.NODE_ENV != "production" )
		if(process.env.NODE_ENV != "production" && !this.$getCookie('Data')) {

			this.$http.post(this.$api + '/unitLogin/organUnitLoginByPassword', {
				// loginName: 'zs1',
				// password: '123456',
				loginName: 'chuangyiwx',
				password: '123456',
				domain: 'http://192.168.1.146:8085',
				platformRole: 4
			}).then(res => {
				// 36000000000000009647
				//10000000000000000012
				//13000000000000010322
				let yang = {
					organunit_id: '11000000000000007192',
					organunitname: 'A用户',
					domain: 'http://192.168.1.146:8085',
					platformRole: '4'
				}
				this.$setCookie('Data', escape(JSON.stringify(yang)));
			})
		}

	},
	router,
	store,
	render: h => h(App),

}).$mount('#app')